(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7240],{

/***/ 47240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ social_links; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
;// CONCATENATED MODULE: ./public/images/icons/facebook-icon.svg
/* harmony default export */ var facebook_icon = ({"src":"/_next/static/media/facebook-icon.bddba469.svg","height":33,"width":32});
;// CONCATENATED MODULE: ./public/images/icons/instagram-icon.svg
/* harmony default export */ var instagram_icon = ({"src":"/_next/static/media/instagram-icon.62c92c6f.svg","height":32,"width":33});
;// CONCATENATED MODULE: ./public/images/icons/linkedin-icon.svg
/* harmony default export */ var linkedin_icon = ({"src":"/_next/static/media/linkedin-icon.d35b075b.svg","height":32,"width":33});
;// CONCATENATED MODULE: ./public/images/icons/x-twitter-icon.svg
/* harmony default export */ var x_twitter_icon = ({"src":"/_next/static/media/x-twitter-icon.27cf549f.svg","height":32,"width":32});
;// CONCATENATED MODULE: ./public/images/icons/youtube-icon.svg
/* harmony default export */ var youtube_icon = ({"src":"/_next/static/media/youtube-icon.64951c74.svg","height":32,"width":32});
// EXTERNAL MODULE: ./src/components/footer/social-links/social.module.scss
var social_module = __webpack_require__(32723);
var social_module_default = /*#__PURE__*/__webpack_require__.n(social_module);
;// CONCATENATED MODULE: ./src/components/footer/social-links/index.tsx












var SocialLinks = function() {
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var socialURLS = headerFooter && headerFooter[0] && headerFooter[0].attributes && headerFooter[0].attributes.Social_Media;
    var faceBookUrl = socialURLS === null || socialURLS === void 0 ? void 0 : socialURLS.Facebook_Url;
    var instagramUrl = socialURLS === null || socialURLS === void 0 ? void 0 : socialURLS.Instagram_Url;
    var linkedInUrl = socialURLS === null || socialURLS === void 0 ? void 0 : socialURLS.LinkedIn_Url;
    var twitterUrl = socialURLS === null || socialURLS === void 0 ? void 0 : socialURLS.Twitter_Url;
    var youtubeUrl = socialURLS === null || socialURLS === void 0 ? void 0 : socialURLS.Youtube_Url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social-links",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-lg-12 col-md-12 col-sm-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (social_module_default()).arrange,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "follow-us",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "footer.follow-us"
                                }),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "icons-row d-flex",
                            children: [
                                faceBookUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-icon fb-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: faceBookUrl,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: facebook_icon,
                                                alt: "facebook"
                                            })
                                        })
                                    })
                                }),
                                instagramUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: instagramUrl,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: instagram_icon,
                                                alt: "instagram"
                                            })
                                        })
                                    })
                                }),
                                linkedInUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: linkedInUrl,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: linkedin_icon,
                                                alt: "linkedin"
                                            })
                                        })
                                    })
                                }),
                                twitterUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: twitterUrl,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: x_twitter_icon,
                                                alt: "twitter"
                                            })
                                        })
                                    })
                                }),
                                youtubeUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: youtubeUrl,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: youtube_icon,
                                                alt: "youtube"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var social_links = (SocialLinks);


/***/ }),

/***/ 32723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrange":"social_arrange__eBUbG"};

/***/ })

}]);